/**
 * Formats the generated email output for submission to Formspree
 * Follows the specified structure with subject line options and markdown-style formatting
 */
export const formatEmailOutput = (email, offerSnapshot = null) => {
  const lines = [];
  
  // Subject Line Options
  const subjectLines = [];
  if (email.subject) {
    subjectLines.push(`- Primary: ${email.subject}`);
  }
  if (email.subjectLines?.fomo) {
    subjectLines.push(`- FOMO: ${email.subjectLines.fomo}`);
  }
  if (email.subjectLines?.curiosity) {
    subjectLines.push(`- Curiosity: ${email.subjectLines.curiosity}`);
  }
  if (email.subjectLines?.value) {
    subjectLines.push(`- Value: ${email.subjectLines.value}`);
  }
  if (email.subjectLines?.question) {
    subjectLines.push(`- Question: ${email.subjectLines.question}`);
  }
  if (email.subjectLines?.special) {
    subjectLines.push(`- Special: ${email.subjectLines.special}`);
  }
  
  if (subjectLines.length > 0) {
    lines.push('**Subject Line Options:**');
    lines.push(...subjectLines);
    lines.push('');
  }
  
  lines.push('---');
  lines.push('');
  
  // Hook
  if (email.hook) {
    lines.push('**Hook:**');
    lines.push(email.hook);
    lines.push('');
  }
  
  // Body
  if (email.body) {
    lines.push('**Body:**');
    lines.push(email.body);
    lines.push('');
  }
  
  lines.push('---');
  lines.push('');
  
  // CTA
  if (email.cta) {
    lines.push('**CTA:**');
    lines.push(email.cta);
  } else if (offerSnapshot?.offerName && offerSnapshot?.offerLink) {
    lines.push('**CTA:**');
    lines.push(`Try [${offerSnapshot.offerName}](${offerSnapshot.offerLink})`);
  }
  
  if (email.cta || (offerSnapshot?.offerName && offerSnapshot?.offerLink)) {
    lines.push('');
  }
  
  lines.push('---');
  lines.push('');
  lines.push('Need help writing emails like this every week?');
  lines.push('You\'re already on the list. Stay tuned.');
  
  return lines.join('\n');
}; 